import { __assign, __extends } from "tslib";
import React, { useContext, useMemo } from 'react';
import { ReadOnlyExperiments } from '@wix/wix-experiments';
import { ExperimentsContext } from './ExperimentsContext';
import { getDisplayName } from './utils';
export function withExperiments(Component, opts) {
    var _a;
    if (opts === void 0) { opts = {}; }
    var displayName = "withExperiments(".concat(getDisplayName(Component), ")");
    var petri_ovr = opts.petri_ovr, readOnly = opts.readOnly;
    if (readOnly) {
        var WrappedComponent = function (props) {
            var _a = useContext(ExperimentsContext), experimentsInstance = _a.experimentsInstance, ready = _a.ready;
            var experiments = useMemo(function () {
                if (petri_ovr && ready) {
                    var bag_1 = experimentsInstance.all();
                    petri_ovr.split(';').forEach(function (override) {
                        var _a = override.split(':'), exp = _a[0], val = _a[1];
                        if (exp && val) {
                            bag_1[exp] = val;
                        }
                    });
                    return new ReadOnlyExperiments({
                        experiments: bag_1,
                    });
                }
                return experimentsInstance;
            }, [experimentsInstance, ready]);
            if (!ready) {
                return null;
            }
            var mergedProps = __assign(__assign({}, props), { experiments: experiments });
            return React.createElement(Component, __assign({}, mergedProps));
        };
        WrappedComponent.displayName = displayName;
        return WrappedComponent;
    }
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.render = function () {
                var _a = this.context, experimentsInstance = _a.experimentsInstance, ready = _a.ready;
                if (process.env.NODE_ENV === 'development' &&
                    !('load' in experimentsInstance)) {
                    throw new Error('PureExperimentsProvider was provided with a ReadOnlyExperiments instance, while withExperiments(Component, { readOnly: false }) was used.');
                }
                if (petri_ovr) {
                    petri_ovr.split(';').forEach(function (override) {
                        var _a;
                        var _b = override.split(':'), exp = _b[0], val = _b[1];
                        if (exp && val) {
                            experimentsInstance.add((_a = {}, _a[exp] = val, _a));
                        }
                    });
                }
                if (ready) {
                    var extraProps = { experiments: experimentsInstance };
                    var mergedProps = __assign(__assign({}, this.props), extraProps);
                    return React.createElement(Component, __assign({}, mergedProps));
                }
                return null;
            };
            return class_1;
        }(React.Component)),
        _a.displayName = displayName,
        _a.contextType = ExperimentsContext,
        _a;
}
//# sourceMappingURL=WithExperimentsHOC.js.map